class DivineTheme {
  constructor() {
    this.moneyFormat = window.Shopify?.money_format || '₹{{amount}}';
    this.initDisclosure();
    this.initCopyButtons();
    this.initQuantity();
    this.initProductSections();
    this.initRecommendations();
  }

  formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.moneyFormat);
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR' }).format(cents / 100);
  }

  announce(message) {
    const status = document.getElementById('ThemeStatus');
    if (status) status.textContent = message;
  }

  initDisclosure() {
    document.querySelectorAll('.mobile-nav').forEach((details) => {
      details.addEventListener('toggle', () => document.body.style.overflow = details.open ? 'hidden' : '');
      details.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { details.open = false; }));
    });
  }

  initCopyButtons(root = document) {
    root.querySelectorAll('[data-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.copy);
          const original = button.textContent;
          button.textContent = 'Copied';
          this.announce(`${button.dataset.copy} copied`);
          setTimeout(() => button.textContent = original, 1600);
        } catch (_) {
          this.announce(`Use code ${button.dataset.copy}`);
        }
      });
    });
  }

  initQuantity(root = document) {
    root.querySelectorAll('[data-quantity]').forEach((wrapper) => {
      const input = wrapper.querySelector('input');
      wrapper.querySelector('[data-minus]')?.addEventListener('click', () => { input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1); input.dispatchEvent(new Event('change')); });
      wrapper.querySelector('[data-plus]')?.addEventListener('click', () => { input.value = Math.min(Number(input.max || 999), Number(input.value || 1) + 1); input.dispatchEvent(new Event('change')); });
    });
  }

  initProductSections() {
    document.querySelectorAll('[data-product-section]').forEach((section) => this.initProduct(section));
  }

  initProduct(section) {
    const variantsNode = section.querySelector('[data-variants-json]');
    const form = section.querySelector('[data-product-form]');
    if (!variantsNode || !form) return;
    const variants = JSON.parse(variantsNode.textContent);
    const idInput = form.querySelector('[name="id"]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const stock = section.querySelector('[data-product-stock]');
    const addButtons = section.querySelectorAll('[data-add-button]');
    const sku = section.querySelector('[data-sku]');

    const showMedia = (id) => {
      if (!id) return;
      section.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', String(item.dataset.mediaId) === String(id)));
      section.querySelectorAll('[data-thumb-id]').forEach((item) => item.classList.toggle('is-active', String(item.dataset.thumbId) === String(id)));
    };
    section.querySelectorAll('[data-thumb-id]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.thumbId)));

    const update = () => {
      const selected = [...section.querySelectorAll('[data-option-position]')].map((group) => group.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index])) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = this.formatMoney(variant.price);
      const stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = this.formatMoney(variant.price);
      if (variant.compare_at_price > variant.price) {
        compare.textContent = this.formatMoney(variant.compare_at_price);
        compare.hidden = false;
      } else compare.hidden = true;
      if (sku) sku.textContent = variant.sku || '—';
      stock?.classList.toggle('is-sold', !variant.available);
      const stockText = stock?.querySelector('[data-stock-text]');
      if (stockText) stockText.textContent = variant.available ? 'In stock — Ready to dispatch' : 'Sold out';
      addButtons.forEach((button) => { button.disabled = !variant.available; button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldText; });
      showMedia(variant.featured_media?.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    section.querySelectorAll('[data-option-position] input').forEach((input) => input.addEventListener('change', update));

    form.addEventListener('submit', async (event) => {
      if (!form.hasAttribute('data-ajax-cart')) return;
      event.preventDefault();
      const button = form.querySelector('[data-add-button]');
      const initialText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add this product');
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
        button.textContent = 'Added to bag ✓';
        this.announce(`${data.product_title} added to bag`);
        setTimeout(() => { button.disabled = false; button.textContent = initialText; }, 1600);
      } catch (error) {
        button.disabled = false;
        button.textContent = initialText;
        this.announce(error.message);
        alert(error.message);
      }
    });

   const stickyButton = section.querySelector('[data-sticky-add]');

stickyButton?.addEventListener('click', async () => {
  if (stickyButton.disabled) return;

  const originalText = stickyButton.textContent;
  stickyButton.disabled = true;
  stickyButton.textContent = 'Processing…';

  try {
    const rootUrl = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(form)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || 'Unable to process order');
    }

    window.location.href = `${rootUrl}checkout`;
  } catch (error) {
    stickyButton.disabled = false;
    stickyButton.textContent = originalText;
    alert(error.message || 'Something went wrong. Please try again.');
  }
});
    update();
  }

  initRecommendations() {
    document.querySelectorAll('[data-recommendations-url]').forEach(async (section) => {
      if (!section.dataset.recommendationsUrl) return;
      try {
        const response = await fetch(section.dataset.recommendationsUrl);
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const fresh = html.querySelector('[data-recommendations-url]');
        if (fresh?.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
      } catch (_) {}
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new DivineTheme());
